import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import Button from 'patient-ping-remedy/packages/button';
import Icon from 'patient-ping-remedy/packages/icon';
import {
  HintTypography,
  SmallTypography,
  StandardSemiBoldTypography, StandardTypography,
} from 'patient-ping-remedy/packages/typography';

export const StatusBadge = styled.div<{ bgColor: string }>`
  display: inline-flex;
  align-items: center;
  height: 30px;
  gap: 10px;
  padding: 0 ${sizes.xSmall};
  border-radius: 100px;
  border: 1px solid ${({bgColor}) => bgColor};
  background-color: ${({bgColor}) => bgColor};
`;

export const AttestButton = styled(Button)<{ canAttest: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({canAttest}) => canAttest ? '69px' : '99px'};
  height: 40px;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${({canAttest}) => canAttest ? colors.purple4 : '#BBBBBB'};
  background-color: ${({canAttest}) => canAttest ? colors.white : '#F2F2F2'};
  color: ${({canAttest}) => canAttest ? colors.purple4 : colors.gray4};
  cursor: ${({canAttest}) => canAttest ? 'pointer' : 'not-allowed'};
  opacity: 1;
`;

export const LockIcon = styled(Icon)`
  font-size: 1.4rem;
  margin-right: ${sizes.xSmall};
  color: ${colors.gray4};
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
`;

export const StatusIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== 'iconColor',
})<{ iconColor: string }>`
  color: ${({iconColor}) => iconColor};
  font-size: 1.6rem;
`;

export const StatusText = styled.span<{ textColor: string }>`
  color: ${({textColor}) => textColor};
  font-size: 1.4rem;
`;

export const SubTextWrapper = styled.div`
  margin-top: ${sizes.small};
`;

export const CompletedDetailsWrapper = styled.div`
  margin-top: ${sizes.small};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StandardSmallTypography = styled(SmallTypography)`
  color: ${colors.charcoal};
`;

export const CancelButton = styled(Button)`
  color: ${colors.purple5} !important;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.small};
`;

export const DetailsCard = styled.div`
  border: 1px solid ${colors.gray2};
  border-radius: 8px;
  padding: ${sizes.small};
  margin-top: ${sizes.small};
`;

export const DetailsTitle = styled(StandardSemiBoldTypography)`
  font-size: 20px;
  line-height: 24px;
  color: ${colors.purple5};
  margin-bottom: ${sizes.small};
  display: block;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${sizes.small};
`;

export const DetailLabel = styled(SmallTypography)`
  color: ${colors.gray4};
  display: block;
`;

export const CareNotStatus = styled(StandardTypography)`
  color: ${colors.primary1};
  font-weight: 600;
  margin-right: 0.3rem;
`;

export const CareNoteDirectAddress = styled(HintTypography)`
  color: ${colors.primary1};
  padding-top: 0.3rem;
`;

export const CareNoteDownloadButton = styled(Button)`
 padding: 0;
`;
